import { render, staticRenderFns } from "./GenerarPDF.vue?vue&type=template&id=9b570d76&"
import script from "./GenerarPDF.vue?vue&type=script&lang=js&"
export * from "./GenerarPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports